export default defineNuxtPlugin(nuxtApp =>
{
	const today = new Date()
	const gdprCookie = useCookie<'accepted' | 'declined' | 'unknown'>('gdprc', {
		default() {
			return 'unknown'
		},
		expires: new Date(today.setFullYear(today.getFullYear() + 1)),
		secure: true,
		watch: 'shallow',
	})

	nuxtApp.provide('gdpr_cookie', gdprCookie)

	return {
		provide: {
			gdprCookie,
		}
	}
})